import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';

import AuthContext from '../../contexts/AuthContext';
import {
  getUserDetail,
  updateUser,
  signIn,
} from '../../modules/NetworkFunction';
import Title from '../../components/Title';
import icPwLook from '../../icons/ic-pwlook.png';
import icPwHide from '../../icons/ic-pwhide.png';

const PASSWORD_REGEX = /^[A-Za-z0-9!@#$%^&+=]{8,15}$/;

function MyPagePwChange() {
  const { auth: token } = useContext(AuthContext);

  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState(null); // user 정보 데이터
  const [pw, setPw] = useState({
    oldPw: '',
    newPw: '',
    pwConfirm: '',
  });

  const [check, setCheck] = useState({
    oldPwCheck: false, // 이전 비번 같은지 확인
    newPwCheck: false, //8자 이상
    pwConfirmCheck: false, //pw랑 같아야함
  });

  const [isTouched, setIsTouched] = useState({
    oldPw: false,
    newPw: false,
    pwConfirm: false,
  });

  const [isOldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setNewPasswordVisible] = useState(false);

  const nextBtnDisabled =
    !(check.oldPwCheck && check.newPwCheck && check.pwConfirmCheck) ||
    pw.newPw === '' ||
    pw.oldPw === '' ||
    pw.pwConfirm === '';

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setData(v.user);
        },
        setIsLoaded,
        (e) => {
          if (e) console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [isLoaded]);

  useEffect(() => {
    if (pw.newPw === pw.pwConfirm && pw.pwConfirm !== '') {
      setCheck((prev) => ({ ...prev, pwConfirmCheck: true }));
    } else {
      setCheck((prev) => ({ ...prev, pwConfirmCheck: false }));
    }
  }, [pw.newPw, pw.pwConfirm]);

  const onChange = (e) => {
    const { value, name } = e.target;
    setPw({ ...pw, [name]: value });
  };

  const reset = () => {
    setPw({
      oldPw: '',
      newPw: '',
      pwConfirm: '',
    });
    setCheck({
      oldPwCheck: false, // 이전 비번 같은지 확인
      newPwCheck: false, //8자 이상
      pwConfirmCheck: false, //pw랑 같아야함
    });
    setIsTouched({
      oldPw: false,
      newPw: false,
      pwConfirm: false,
    });
  };

  const validatePassword = (target, password) => {
    const name = target === 'oldPw' ? 'oldPwCheck' : 'newPwCheck';
    setCheck({ ...check, [name]: PASSWORD_REGEX.test(password) });
  };

  const handleInputBlur = (e) => {
    const { name } = e.target;
    setIsTouched({ ...isTouched, [name]: true });
  };

  const oldPasswordInputIsInvalid = isTouched.oldPw && !check.oldPwCheck;
  const newPasswordInputIsInvalid = isTouched.newPw && !check.newPwCheck;
  const pwConfirmInputIsInvalid = isTouched.pwConfirm && !check.pwConfirmCheck;

  const passwordIcon = (visible) => {
    return (
      <span>
        <img
          src={visible ? icPwHide : icPwLook}
          width={30}
          alt={`비밀번호 ${visible ? '숨기기' : '보기'}`}
        />
      </span>
    );
  };

  return (
    <>
      <Title title="비밀번호 수정" />
      <form>
        <input hidden type="text" autoComplete="username" />
        <p
          style={{
            fontSize: 18,
            color: oldPasswordInputIsInvalid ? '#FF8A00' : '#000',
          }}
        >
          현재 비밀번호*
        </p>
        <div className="input-box">
          <Input
            type={isOldPasswordVisible ? 'text' : 'password'}
            name="oldPw"
            value={pw.oldPw}
            onBlur={handleInputBlur}
            onChange={(e) => {
              onChange(e);
              validatePassword(e.target.name, e.target.value);
            }}
            isInvalid={oldPasswordInputIsInvalid}
            autoComplete="current-password"
          />
          <span
            style={{ cursor: 'pointer', marginRight: '8px' }}
            onClick={() => {
              setOldPasswordVisible((prev) => !prev);
            }}
          >
            {isOldPasswordVisible ? passwordIcon(true) : passwordIcon(false)}
          </span>
          <p style={{ color: '#FF8A00' }}>
            {oldPasswordInputIsInvalid && '비밀번호를 8-15자로 설정해주세요.'}
          </p>
        </div>
        <p
          style={{
            fontSize: 18,
            color: newPasswordInputIsInvalid ? '#FF8A00' : '#000',
          }}
        >
          새 비밀번호*
        </p>
        <div className="input-box">
          <Input
            type={isNewPasswordVisible ? 'text' : 'password'}
            name="newPw"
            value={pw.newPw}
            onBlur={handleInputBlur}
            onChange={(e) => {
              onChange(e);
              validatePassword(e.target.name, e.target.value);
            }}
            isInvalid={newPasswordInputIsInvalid}
            autoComplete="new-password"
          />
          <span
            style={{ cursor: 'pointer', marginRight: '8px' }}
            onClick={() => {
              setNewPasswordVisible((prev) => !prev);
            }}
          >
            {isNewPasswordVisible ? passwordIcon(true) : passwordIcon(false)}
          </span>
          <p style={{ color: '#FF8A00' }}>
            {newPasswordInputIsInvalid && '비밀번호를 8-15자로 설정해주세요.'}
          </p>
        </div>

        <p
          style={{
            fontSize: 18,
            color: pwConfirmInputIsInvalid ? '#FF8A00' : '#000',
          }}
        >
          새 비밀번호 확인*
        </p>
        <div className="input-box">
          <Input
            type="password"
            name="pwConfirm"
            value={pw.pwConfirm}
            onChange={onChange}
            onBlur={handleInputBlur}
            isInvalid={pwConfirmInputIsInvalid}
            autoComplete="new-password"
          />
          <p style={{ color: check.pwConfirmCheck ? '#0C9429' : '#FF8A00' }}>
            {isTouched.pwConfirm
              ? check.pwConfirmCheck
                ? '비밀번호가 확인되었습니다.'
                : '비밀번호가 다릅니다.'
              : ''}
          </p>
        </div>

        <ButtonContainer>
          <RoundButton
            type="button"
            backgroundColor={nextBtnDisabled ? '#CCC' : '#FFB600'}
            color={nextBtnDisabled ? '#4D4D4D' : '#FFF'}
            disabled={nextBtnDisabled}
            onClick={() => {
              const signInParam = {
                userMail: data.userMail,
                userPW: pw.oldPw,
              };
              signIn(
                signInParam,
                (e) => {},
                () => {
                  setCheck({ ...check, oldPwCheck: true });
                  let d = {
                    userNo: data.userNo,
                    userPW: pw.newPw,
                  };
                  updateUser(
                    d,
                    () => {
                      alert('비밀번호가 변경되었습니다.');
                    },
                    () => {},
                    (v) => {
                      console.log(v);
                    },
                    token
                  );
                  reset();
                },
                (e) => {
                  console.log(e);
                  alert('현재 비밀번호를 다시 확인해주세요.');
                }
              );
            }}
          >
            저장
          </RoundButton>
        </ButtonContainer>
      </form>
    </>
  );
}
export default MyPagePwChange;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px 0 30px 0;
`;

const RoundButton = styled.button`
  display: flex;
  width: 100px;
  height: 40px;
  padding: 6px 6px;
  text-align: center;
  border-radius: 20px;
  font-size: 20px;
  border-width: 0;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};

  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const Input = styled.input`
  width: 295px;
  height: 38px;
  margin-right: 7px;
  border-radius: 5px;
  outline: ${(props) =>
    props.isInvalid ? '1px solid #FF8A00' : '1px solid #C4C4C4'};
  color: #848484;
  padding-left: 10px;
  &&& {
    border: 0;
  }
`;
